import {Injectable} from '@angular/core';
import {Autowired} from '@angular-ru/autowired';
import {WebUtilities} from '@app/core/utilities/web.utilities';
import {Observable} from 'rxjs';
import {IRecuperationListeDonneesRequete} from '@app/core/interfaces/actions/i-recuperation-liste-donnees-requete';
import {SgiRestService} from '@app/core/services/sgi/sgi-rest.service'
import { API_POUR_RECUPERER_LISTE_CLIENT_GARANTS } from '@app/core/constantes';

@Injectable({providedIn: 'root'})
export class SelectGarantRestApiService implements IRecuperationListeDonneesRequete {
  @Autowired() restService: SgiRestService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    let sendData = {
      TakeAll: true,
      ItemToSearch: {}
    }
    return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_POUR_RECUPERER_LISTE_CLIENT_GARANTS}`, sendData);
  }

  requeteSuppression(data: any, args?: any): Observable<any> | Promise<any> | any {
    let id = null; try { id = data.id ? data.id : null; } catch (e) {}
    return this.restService.deleteRequest(`${WebUtilities.baseUrlApi()}evenement/${id}`);
  }
}
